module.exports = __webpack_public_path__ + "img/j2.9f0f666b.png";